import { Checkbox, ListaControlesSkeleton, Stack, Text } from "@/components/ui";
import { useOrganizacionesParaCeco } from "../hooks/use-catalogos-contables-admin";

/**
 * Selector (multi) de organizaciones para un CeCo · relación M:N: un CeCo puede
 * pertenecer a varias organizaciones. Grupo de checkboxes (solo 6 sociedades activas),
 * controlado por `value` (números de sociedad) / `onChange`.
 */
export function OrganizacionesPicker({
  value,
  onChange,
  error,
}: {
  value: string[];
  onChange: (numerosSociedad: string[]) => void;
  error?: string;
}) {
  const { data: orgs, isLoading } = useOrganizacionesParaCeco();

  const toggle = (numeroSociedad: string, checked: boolean) => {
    onChange(
      checked
        ? [...value, numeroSociedad]
        : value.filter((s) => s !== numeroSociedad)
    );
  };

  return (
    <div>
      <Text size="sm" fw={500} className="mb-1.5">
        Organizaciones <span className="text-peligro-600">*</span>
      </Text>
      {isLoading ? (
        <ListaControlesSkeleton filas={6} control="checkbox" className="gap-2" etiqueta="Cargando organizaciones…" />
      ) : (orgs?.length ?? 0) === 0 ? (
        <Text size="sm" c="dimmed">
          No hay organizaciones activas.
        </Text>
      ) : (
        <Stack gap="xs">
          {orgs!.map((o) => (
            <Checkbox
              key={o.numeroSociedad}
              checked={value.includes(o.numeroSociedad)}
              onCheckedChange={(c) => toggle(o.numeroSociedad, c === true)}
              label={
                <span>
                  <span className="font-mono text-xs text-muted-foreground">{o.numeroSociedad}</span>
                  {" · "}
                  {o.nombre}
                </span>
              }
            />
          ))}
        </Stack>
      )}
      {error ? (
        <Text size="xs" className="mt-1 text-peligro-600">
          {error}
        </Text>
      ) : null}
    </div>
  );
}
